'use client';
import classNames from 'classnames';
import { ButtonHTMLAttributes, ReactElement } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Additional text
   */
  description?: string;
  /**
   * Size in relation to container
   */
  size: 'full-width' | 'half-width' | 'quarter-width';
  /**
   * Main text
   */
  title: string;
  /**
   * The default behavior of the button (only use with "submit")
   */
  type?: 'submit';
  /**
   * Styling variant
   */
  variant: 'filled' | 'outlined' | 'underlined';
}

const Button = (props: ButtonProps): ReactElement => {
  const {
    className,
    description,
    size,
    title,
    type = 'button',
    variant,
    ...rest
  } = props;

  return (
    <button
      {...rest}
      className={classNames(variant, size, className)}
      title={title}
      type={type}
    >
      {title}
      {description && <span>{description}</span>}
    </button>
  );
};

export default Button;
